var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 22.0999H14.4M6 8.8999C6 5.58619 8.68629 2.8999 12 2.8999C15.3137 2.8999 18 5.58619 18 8.8999C18 11.3603 16.5191 13.374 14.4 14.2999V17.8999C14.4 18.5626 13.8627 19.0999 13.2 19.0999H10.8C10.1373 19.0999 9.6 18.5626 9.6 17.8999V14.4006C7.48091 13.4748 6 11.3603 6 8.8999Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutions);
export default __webpack_public_path__ + "static/media/solutions.5bb103592d292d0f39bde76a97cf635d.svg";
export { ForwardRef as ReactComponent };